export const actionTypes = {
  // get Media type
  GET_GALLERY_CATEGORY_TYPE_START: 'GET_GALLERY_CATEGORY_TYPE_START',
  GET_GALLERY_CATEGORY_TYPE_SUCCESS: 'GET_GALLERY_CATEGORY_TYPE_SUCCESS',
  GET_GALLERY_CATEGORY_TYPE_FINISH: 'GET_GALLERY_CATEGORY_TYPE_FINISH',
}
